export const AzureOauthUrl = '/AP/Azure/OAuth';
